export default "__VITE_PUBLIC_ASSET__b6471684__"